import { createContext, useContext } from "react";

const ExaminationContext = createContext({
  mode: "standalone",
  examinationId: null,
  isReadOnly: true,
  registerAutoSave: null,
});

export const ExaminationProvider = ExaminationContext.Provider;

export function useExaminationContext() {
  return useContext(ExaminationContext);
}

export default ExaminationContext;
